<template>
    <el-col :span="8" style="height: 100%;">
        <div class="order_money">
             <div class="head">
                <span>订单金额分布情况</span>
            </div>
            <div class="content">
                <div style="height: 310px" ref="chart"></div>
            </div>
        </div>
    </el-col>
</template>

<script>
export default {
    data(){
        return{
            myCharts:null,
            chartData:[
                {value: 2856, name: '0~100（次）',itemStyle:{color: '#8D98B3'}},
                {value: 310, name: '100~300（次）',itemStyle:{color: '#356AFF'}},
                {value: 1422, name: '300~500（次）',itemStyle:{color: '#766FFF'}},
                {value: 854, name: '500~800（次）',itemStyle:{color: '#FF9F7F'}},
                {value: 334, name: '≥800（次）',itemStyle:{color: '#FE4D45'}}
            ]
        }
    },
    mounted(){
        this.$nextTick(() => {
            this.initChart()
            window.addEventListener('resize', () => {
                this.myCharts.resize();
            })
        })
    },
    methods:{
        initChart(){
            this.myCharts =this.$echarts.init(this.$refs.chart);
            this.setOptions(this.chartData)
        },
        setOptions(data){
            let options = {
                // 提示框组件
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                
                // 系列列表。每个系列通过 type 决定自己的图表类型
                series: {
                    name: '订单金额分布情况', 
                    type:'pie',
                    radius: ['50%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        // label: {
                        //     show: true,
                        //     fontSize: '30',
                        //     fontWeight: 'bold'
                        // }
                    },
                    labelLine: {
                        show: false
                    },
                    data: data
                },
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    },
                }
            }
            this.myCharts.setOption(options)
            
        }
    }
}
</script>


<style scoped lang="scss">
.order_money {
    height: 100%;
    background:rgba(255,255,255,1);
    box-shadow:0px 4px 8px rgba(0,0,0,0.06);
    border-radius:6px;
    overflow: hidden;
    .head{
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 54px;
        padding: 0 24px;
        span {color: #2E3458; font-size: 16px; font-weight: 800;}
        img {width: 18px; height: 18px; cursor: pointer;}
        border-bottom: 1px solid #F6F6F6;
    }
    .content{
        height: 306px;
    }
}
</style>